import React from 'react';
import { getBrandCodeDomain } from '../utils/utils';
const Header = () => {

    let brand  = getBrandCodeDomain();
    
    let logo = "/assets/logo/NW-logo.svg";
    let bankName = 'Natwest bank';
    let websiteLink= "https://www.natwest.com/";
    if(brand === 'rbs'){
        bankName = 'Royal bank of scotland';
        logo = "/assets/logo/RB-logo.svg";
        websiteLink= "https://www.rbs.co.uk/";
    }else if(brand === 'ubn'){
        bankName = 'Ulster bank';
        logo = "/assets/logo/UB-logo.svg";
        websiteLink= "https://www.ulsterbank.co.uk/";
    }else if(brand === 'natwesti'){
        bankName = 'Natwest International';
        logo = "/assets/logo/NWI-logo.svg";
        websiteLink= "https://www.natwestinternational.com/";
    }
    return( 
        <header className='zb-masthead-container'>
            <div className='zb-masthead App-masthead'>
                {/* eslint-disable-next-line */}
                <a role='link' rel="noreferrer" href={websiteLink} aria-label={`${bankName} logo opens in new tab`} target="_blank">
                    <img src={logo} alt={`${bankName} logo`} aria-label={`${bankName} logo`} />
                </a>
            </div>
        </header>
    );
}
export default Header;

